export default {
  webstoreContent: (state) => state.webstoreContent,
  checkoutContent: (state) => state.checkoutContent,
  footerContent: (state) => state.footerContent,
  checkoutSharedContent: (state) => state.checkoutSharedContent,
  webstoreProductContent: (state) => state.webstoreProductContent,
  webstoreGlobals: (state) => state.webstoreGlobals,
  testProduct: (state) => state.testProduct,
  renewalsPersistedVariables: (state) => state.renewalsPersistedVariables,
  contractDisclaimer: (state, getters, rootState) => {
    let endDate = new Date(rootState.checkout.contract.endDate).toLocaleString(
      "default",
      {
        month: "long",
        day: "numeric",
        year: "numeric",
      }
    );
    return state.webstoreContent.webstoreBody.contract_info.replace(
      "CONTRACT_END_DATE",
      endDate
    );
  },
};
